import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UnsubscribeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"unsubscribe"}/>
}
